<template>
    <div class="login-container">
        <el-container>
            <el-main>
                <el-row class="login-raw">
                    <el-col :span="12" class="hidden-xs-only">
                        <div class="logo-zone">
                            <div class="siteName">
                                {{ siteInfo.SiteName }}
                            </div>
                            <img class="box-bg" :alt="siteInfo.SiteName" src="/src/assets/login/login-box-bg.svg">
                        </div>
                    </el-col>
                    <el-col class="login-component" :xs="{ span:20, offset:2 }" :md="{ span:6,offset:2 }">
                        <el-form @keyup.enter.native="submitForm"
                            v-if="showLoginForm"
                            class="loginForm"
                            label-position="top"
                            size="large"
                            :model="loginForm"
                            style="max-width: 400px;height: 384px;">
                            <div class="siteName" style="line-height: 142px; margin-bottom: 0;">
                                账户登录
                            </div>
                            <el-input 
                                v-model="loginForm.userName" 
                                class="formItem"
                                placeholder="请输入账户名">
                                <template #prefix>
                                    <el-icon class="el-input__icon"><user /></el-icon>
                                </template>
                            </el-input>
                            
                            <el-input v-model="loginForm.passWord"
                                class="formItem"
                                type="password"
                                show-password
                                placeholder="密码">
                                <template #prefix>
                                    <el-icon class="el-input__icon"><lock /></el-icon>
                                </template>
                            </el-input>
                            <el-checkbox class="formItem" v-model="loginForm.remberMe" label="记住我"></el-checkbox>
                            <div>
                                <el-button style="width:100%" type="primary" @click="submitForm" size="large">登录</el-button>
                            </div>
                        </el-form>
                        <el-form @keyup.enter.native="submitPhoneForm"
                            v-if="showPhoneLogin"
                            class="loginForm QwePhoneField"
                            label-position="top"
                            size="large"
                            :model="loginForm"
                            style="max-width: 400px;height: 384px;">
                            <div class="siteName" style="line-height: 142px; margin-bottom: 0;">
                                手机号登录{{ siteInfo.PhoneRegister ? "/注册": "" }}
                            </div>
                            <el-input 
                                v-model="loginForm.phone" 
                                class="formItem"
                                placeholder="请输入大陆手机号">
                                <template #prefix>
                                    <el-icon class="el-input__icon"><phone /></el-icon>
                                </template>
                            </el-input>
                            
                            <el-input v-model="loginForm.code"
                                :class="{'button-disabled' : computedcheckInButtonDisable }"
                                class="formItem"
                                placeholder="验证码"
                                :disabled="computedcheckInInputDisable">
                                <template #prefix>
                                    <el-icon class="el-input__icon"><lock /></el-icon>
                                </template>
                                <template #append>
                                    <el-button @click="sendVerifierCode" :disabled="computedcheckInButtonDisable"> {{ checkInButton }} </el-button>
                                </template>
                            </el-input>
                            <el-checkbox class="formItem" v-model="loginForm.remberMe" label="记住我"></el-checkbox>
                            <div>
                                <el-button style="width:100%" type="primary" @click="submitPhoneForm" size="large">登录{{ siteInfo.PhoneRegister ? "/注册": "" }}</el-button>
                            </div>
                        </el-form>
                        <iframe 
                            v-else-if="showThirdPartyLogin"
                            scrolling="no" 
                            class="thirdPartyFrame" 
                            :src="thirdPartyLoginSrc">
                        </iframe>
                        <div v-if="loginModeCount > 1" style="width:100%">
                            <div class="other-login-divider"><span>或</span></div>
                            <div class="toggle-login-divider">
                                <el-button @click="toggleLoginMode(0)"> 账号登录 </el-button> 
                                <el-button v-if="siteInfo.ThirdPartyLogin" @click="toggleLoginMode(1)"> {{ thirdPartyLoginName }} </el-button>
                                <el-button v-if="siteInfo.PhoneLogin" @click="toggleLoginMode(2)"> 手机号登录{{ siteInfo.PhoneRegister ? "/注册": "" }} </el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-main>
        </el-container>
    </div>
</template>

<style scoped>
    .el-container{
        height: 100%;
        width: 100%;
        position: absolute;
    }

    .el-main{
        height: 100%;
        width: 100%;
    }
    .login-raw{
        height: 100%;
        width: 100%;
        align-items: center;
    }

    .logo-zone{
        color: white;
        text-align: center;
    }

    .siteName{
        font-size: 2rem;
        font-weight: 500;
        margin-bottom: 4rem;
    }

    .formItem{
        margin-bottom: 1rem;
    }

    .thirdPartyFrame{
        border: none;
        overflow: hidden;
        height: 380px;
        width: 378px;
    }

   .other-login-divider {
        position: relative;
        width: 100%;
        color: #b5b8be;
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
    }

    .other-login-divider::before {
        position: absolute;
        top: 50%;
        display: block;
        width: 45%;
        height: 1px;
        background: #ebecee;
        border-radius: 2px;
        content: "";
        right: 0;
    }
    .other-login-divider:after {
        position: absolute;
        top: 50%;
        display: block;
        width: 45%;
        height: 1px;
        background: #ebecee;
        border-radius: 2px;
        content: "";
    }

    .toggle-login-divider {
        justify-content: center;
        line-height: 44px;
        display: flex;
        margin-top: 0.8rem;
    }

    .login-divider-option{
        color: #409eff;
    }

    .login-component{
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    @media screen and (min-width: 768px){
        .login-container:before {
            background-image:  url(/src/assets/login/login-bg.svg);
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            margin-left: -48%;
            background-position: 100%;
            background-repeat: no-repeat;
            background-size: auto 100%;
            content: " ";
        }
        .toggle-login-divider .el-button{
            width: 50%;
        }
    }
    
    @media only screen and (max-width: 768px) {
        .login-container{
            height: 100%;
            background-color: #0960bd;
        }
        .loginForm .el-button{
            width:100%
        }
        .login-container .login-raw{
            background-color: white;
            border-radius: 8px;
            padding-top:10vh;
            padding-bottom:10vh;
        }
        .el-tabs__header{
            display: none !important;
        }
    }
    
  
    .box-bg{
        width: 18rem;
    }
    .loginfont{
        font-size: 2rem;
        font-weight: 500;
    }
    .loginForm label.el-form-item__label {
        display: none !important;
    }
</style>

<script>
    import { login, getCSRF, externalLogin, phonelogin } from "../../apis/httpHelper"
    import 'element-plus/theme-chalk/display.css'
    import { User, Lock, Iphone } from '@element-plus/icons-vue'
    import { ElNotification } from "element-plus"
    import { RouterMeta } from "../../route"
    import { LoginMode } from "."
    import codePhone from "../../components/Fields/PhoneField/CodePhone"

    export default {
        mixins:[codePhone],
        name:"Login",
        data:function(){
            return {
               loginForm: {
                    userName:"",
                    passWord:"",
                    phone:"",
                    code:"",
                    remberMe:false
               },
               loginMode: LoginMode.LoginForm,
               thirdPartyLoginSrc:"",
               thirdPartyLoginName:"",
               loginModeCount:1
            }
        },
        created:function(){
            if(this.userInfo.IsAuthenticated){
                this.$router.push("/")
            }
            if(this.siteInfo.ThirdPartyLogin){
                if(!this.siteInfo.OnlyThirdPartyLogin){
                    this.loginModeCount = this.loginModeCount + 1;
                }
            }
            if(this.siteInfo.PhoneLogin){
                this.loginModeCount = this.loginModeCount + 1;
            }
            if(this.siteInfo.ThirdPartyLogin){
                this.loginMode = LoginMode.ThirdPartyLogin;
                externalLogin(this.$store.state.routePath)
                .then(x=>{
                    if(x.Result.Successed && x.Result.IsAutoRedirect && !this.$store.state.routeInfo.human){
                        window.location.href = x.Result.RedirectUrl;
                    }
                    else{
                        this.thirdPartyLoginSrc = x.Result.RedirectUrl;
                        this.thirdPartyLoginName = x.Result.RedirectName ?? "企业微信登录";
                    }
                })
            }
        },
        computed:{
            siteInfo:function(){
                return this.$store.state.siteInfo
            },

            userInfo:function(){
                return this.$store.state.userInfo
            },

            showLoginForm:function(){
                return this.loginMode == LoginMode.LoginForm;
            },

            showThirdPartyLogin:function(){
                return this.loginMode == LoginMode.ThirdPartyLogin;
            },

            showPhoneLogin:function(){
                return this.loginMode == LoginMode.PhoneLogin;
            },

            phone:function(){
                return this.loginForm.phone;
            },

            checkInCodeInput:function(){
                return this.loginForm.code;
            }
        },
        components:{
            "user":User,
            "lock":Lock,
            "phone":Iphone
        },
        methods:{
            toggleLoginMode:function(loginMode){
                this.loginMode = loginMode;
            },



            submitForm:function(){
                let data = {
                    userName:this.loginForm.userName,
                    userPassword:this.loginForm.passWord,
                    remberMe:true
                };

                login(data).then(response=>{
                    this.successeResponse(response)
                }).catch(x=>{
                    console.log(x);
                })
            },

            submitPhoneForm:function(){
                let data = {
                    phone:this.loginForm.phone,
                    code:this.loginForm.code,
                    remberMe:true
                };

                phonelogin(data).then(response=>{
                    this.successeResponse(response)
                }).catch(x=>{
                    console.log(x);
                })
            },

            successeResponse:function(response){
                response.Result.IsAuthenticated = true;
                this.$store.commit("SetUserInfo", response.Result);
                getCSRF().then(y=>{
                    this.$store.commit("SetVerification", y.Result);
                    let routeInfo = this.$store.state.routeInfo;
                    if(routeInfo.name == RouterMeta.login.name || routeInfo.name == ""){
                        this.$router.push(RouterMeta.index.path);
                    }
                    else{
                        this.$router.push(this.$store.state.routePath);
                    }
                    ElNotification({
                        title: '你好！' + response.Result.NickName,
                        message: '欢迎使用'+this.$store.state.siteInfo.SiteName,
                        type: 'success',
                        duration: 3000
                    });
                })
            }
        }
    }
</script>